import React, { useEffect } from 'react'; 
import Navbar from '../Navbar';
import SelficWorkflowsBody from './SelficWorkflowsBody';
import Footer from '../Footer';
import { appInsights } from '../../api/AppInsights';
const SelficWorkflows = () => {
  useEffect(() => {
        appInsights.trackPageView({ name: 'Selfic Workflows Page' });
      }, []);
      
  return (
    <>
      <Navbar />
      <SelficWorkflowsBody />
      <Footer />
    </>
  );
};

export default SelficWorkflows;